
import React from "react";
import styles from "../../assets/style.module.css";

export interface LogoStripProps {
    logos: string[];
}

function LogoStrip({ logos }: LogoStripProps) {

    // rendered twice so the marquee loops without a gap
    const loop = [...logos, ...logos];

    return (<section className={styles["logos"]}>
        <div className={styles["logos-track"]} style={{ animationDuration: `${Math.max(logos.length, 4) * 6}s` }}>
            {loop.map((l, i) => (<div key={`${l}-${i}`} className={styles["logo-box"]} aria-hidden={i >= logos.length}>
                <img src={l} alt="" loading="lazy" />
            </div>))}
        </div>
    </section>);
}

export default LogoStrip;
